import React from 'react';
import CONSTANTS from './constants.js'
import {connect} from 'react-redux'

const mapDispatchToProps =  (dispatch) => {
    return {
        sessionController: (adjustTimer) => dispatch(CONSTANTS.ACTION_CREATORS.set_session_length(adjustTimer)),
    };
} 

class SessionLength extends React.Component{
    constructor(props){
        super(props);
        
        this.incrementTimer = this.incrementTimer.bind(this);
        this.decrementTimer = this.decrementTimer.bind(this);
    }
    
    incrementTimer(){
        this.props.sessionController(CONSTANTS.ACTIONS.INCREMENT_TIMER);
    }
    
    decrementTimer(){
        this.props.sessionController(CONSTANTS.ACTIONS.DECREMENT_TIMER);
    }
    
    render(){
        return(
            <div className='sessionLength outerWrapper borderBox'>
                <div className='innerWrapper'>
                    <h2 id='session-label'>Session Length</h2>
                    <button id="session-decrement" type='button' onClick = {this.decrementTimer}>-</button>
                    <span id="session-length">{this.props.sessionL}</span>
                    <button id="session-increment" type='button' onClick = {this.incrementTimer}>+</button>
                </div>
            </div>
        )
    }
}

export default connect(CONSTANTS.MAP_STATE_TO_PROPS,mapDispatchToProps)(SessionLength);